import FtpConfigs from '../../FtpConfigs';
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {CONFIG_TYPES} from '../../FileTypes';
import ReactTablePopoverMenu from "../../../Components/ReactTable/ReactTablePopoverMenu";
import _ from "lodash";

const FtpConfigButtons = (props) => {
    const configTypesWithMappings = [
        CONFIG_TYPES.FILE_TYPE.name,
        CONFIG_TYPES.SALES.name,
        CONFIG_TYPES.ITEMS.name,
        CONFIG_TYPES.STORES.name,
    ]

    const [uncontrolledIsOpen, setUncontrolledIsOpen] = useState(false);
    const isControlled = typeof props.setIsConfigPopOverOpen === 'function';
    const isPopOverOpen = isControlled ? props.isConfigPopOverOpen : uncontrolledIsOpen;
    const setIsPopOverOpen = isControlled ? props.setIsConfigPopOverOpen : setUncontrolledIsOpen;

    return (
        <ReactTablePopoverMenu id={`mapping-po-${props.ftp}`}
                               title={'Mapping'}
                               isPopOverOpen={Boolean(isPopOverOpen)}
                               setIsPopOverOpen={setIsPopOverOpen}
        >
            { Object.values(CONFIG_TYPES)
                .filter(type => _.includes(configTypesWithMappings, type.name))
                .map(function (value) {
                return <FtpConfigs
                    key={value.getName()}
                    className={value.getName()}
                    ftp={props.ftp}
                    buttonTitle={value.getFileTypeName()}
                    configType={value}
                    setIsPopoverOpen={setIsPopOverOpen}
                />
            })
        }
        </ReactTablePopoverMenu>
    );
};

FtpConfigButtons.propTypes = {
    ftp: PropTypes.string,
    isConfigPopOverOpen: PropTypes.bool,
    setIsConfigPopOverOpen: PropTypes.func,
};
export default FtpConfigButtons;
